import { render, staticRenderFns } from "./ed-designer.component.vue?vue&type=template&id=8c3a4396&scoped=true&"
import script from "./ed-designer.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer.component.scss?vue&type=style&index=0&id=8c3a4396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3a4396",
  null
  
)

export default component.exports